import { useFlag } from '@calendly/feature-check-react'
import { Form } from '@calendly/form'
import { usePageTitle } from '@calendly/hooks'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'
import { useDispatch, useSelector } from 'react-redux'

import { saveOrgWorkflowsSettings } from 'actions/current_organization'
import LoadingState from 'components/core/loading_state'
import { orgWorkflowsSettingsSelector } from 'selectors/current_organization'
import { camelize, snakeize } from 'services/string_utils'

import { useFetchWorkflowsSettingsQuery, useUpdateWorkflowsSettingsMutation } from '../api'
import { Description, Question } from '../styles'
import { FormContent } from './form_content'

const WorkflowsHelpCenterLink = ({ children }) => (
  <Link href="https://help.calendly.com/hc/en-us/articles/360051017814" target="_blank" rel="noopener noreferrer">
    {children}
  </Link>
)

export const Workflows = () => {
  const dispatch = useDispatch()
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction')
  const pageTitlePostfix = I18n.t('publisher.admin.permissions.title')
  const [updateWorkflowsSettings] = useUpdateWorkflowsSettingsMutation()

  const monolithSettings = useSelector(orgWorkflowsSettingsSelector)
  const { data, isLoading } = useFetchWorkflowsSettingsQuery({}, { skip: !workflowsExtractionEnabled })
  const settings = data ? data.resource : camelize(monolithSettings)

  usePageTitle(`${I18n.t('publisher.organization_settings.workflows.title')} - ${pageTitlePostfix}`)

  const handleSubmit = (newSettings) => (
    workflowsExtractionEnabled
      ? dispatch(updateWorkflowsSettings(newSettings))
      : dispatch(saveOrgWorkflowsSettings(snakeize(newSettings)))
  )

  if (isLoading) return <LoadingState />

  return (
    <>
      <Description>
        {HtmlParser(I18n.t('publisher.organization_settings.workflows.description'), { WorkflowsHelpCenterLink })}
      </Description>
      <Question>
        {I18n.t('publisher.organization_settings.workflows.enabled_for.question')}
      </Question>
      <Form
        initialValues={settings}
        onSubmit={handleSubmit}
      >
        <FormContent />
      </Form>
    </>
  )
}
